import { Injectable } from '@angular/core';
import { WorkFlowService } from './work-flow.service';
@Injectable({
    providedIn: 'root',
})
export class ReportsService {
  constructor(
    private workFlow: WorkFlowService
  ) {}

  getLocalizedFields(language: string): Map<string, string>{
    let localizedFields: Map<string, string> = new Map<string, string>();
    localizedFields.set("Text", language == 'it-IT' ? 'TextLOC' : 'TextENG');
    localizedFields.set("Description", language == 'it-IT' ? 'DescriptionLOC' : 'DescriptionENG');
    localizedFields.set("FunctionalAreas", language == 'it-IT' ? 'FunctionalAreas' : 'FunctionalAreasENG');
    localizedFields.set("Tip", language == 'it-IT' ? 'TipLOC' : 'TipENG');
    return localizedFields;
  }

  setObjectsEmptyFields<T>(objects: T[]): T[]{
    objects.forEach((item) => {
      this.getLocalizedFields(this.workFlow.getLanguageForCms()).forEach((field, key) => {
        item[field] = item[field] == '' ? item[this.getLocalizedFields('it-IT').get(key)] : item[field]
      })
    })
    return objects;
  }

}
